// extracted by mini-css-extract-plugin
export default {"wrapper":"LoadMoreTrigger_wrapper__TgsbH"};